export let BookFlightTab = /*#__PURE__*/function (BookFlightTab) {
  BookFlightTab["Return"] = "Return";
  BookFlightTab["RoundTrip"] = "Round Trip";
  BookFlightTab["OneWay"] = "One-way";
  BookFlightTab["MultiCity"] = "Multi-city";
  return BookFlightTab;
}({});
export let BookFlightAirportDropdown = /*#__PURE__*/function (BookFlightAirportDropdown) {
  BookFlightAirportDropdown["From"] = "from";
  BookFlightAirportDropdown["To"] = "to";
  return BookFlightAirportDropdown;
}({});
export let PassengerDetails = /*#__PURE__*/function (PassengerDetails) {
  PassengerDetails["Adult"] = "adult";
  PassengerDetails["Youth"] = "youth";
  PassengerDetails["Child"] = "child";
  PassengerDetails["Infant"] = "infant";
  return PassengerDetails;
}({});
export let CabinClass = /*#__PURE__*/function (CabinClass) {
  CabinClass["Economy"] = "PE";
  CabinClass["Business"] = "FB";
  return CabinClass;
}({});
export let BookFlightTabSections = /*#__PURE__*/function (BookFlightTabSections) {
  BookFlightTabSections["RoundTrip"] = "Round Trip";
  BookFlightTabSections["OneWay"] = "One Way";
  BookFlightTabSections["Return"] = "Return";
  return BookFlightTabSections;
}({});
export let BookFlightMainTabSections = /*#__PURE__*/function (BookFlightMainTabSections) {
  BookFlightMainTabSections["BookFlight"] = "Book Flight";
  BookFlightMainTabSections["ManageBooking"] = "Manage Booking";
  BookFlightMainTabSections["CheckIn"] = "Check-In";
  BookFlightMainTabSections["FlightStatus"] = "Flight Status";
  BookFlightMainTabSections["MoreServices"] = "More";
  return BookFlightMainTabSections;
}({});
export let FlightStatusType = /*#__PURE__*/function (FlightStatusType) {
  FlightStatusType["FlightNumber"] = "Flight Number";
  FlightStatusType["Route"] = "Route";
  return FlightStatusType;
}({});
export let FlightScheduleAirportDropdown = /*#__PURE__*/function (FlightScheduleAirportDropdown) {
  FlightScheduleAirportDropdown["From"] = "from";
  FlightScheduleAirportDropdown["To"] = "to";
  return FlightScheduleAirportDropdown;
}({});
export let FlightScheduleTab = /*#__PURE__*/function (FlightScheduleTab) {
  FlightScheduleTab["Return"] = "Return";
  FlightScheduleTab["OneWay"] = "OneWay";
  return FlightScheduleTab;
}({});
export let FlightScheduleReturnTabs = /*#__PURE__*/function (FlightScheduleReturnTabs) {
  FlightScheduleReturnTabs["Return"] = "Return";
  FlightScheduleReturnTabs["Depart"] = "Depart";
  return FlightScheduleReturnTabs;
}({});
export let MilesCalculator = /*#__PURE__*/function (MilesCalculator) {
  MilesCalculator["Airways"] = "Thai Airways";
  MilesCalculator["StarAlliance"] = "Star Alliance";
  return MilesCalculator;
}({});
export let MilesTabs = /*#__PURE__*/function (MilesTabs) {
  MilesTabs["EarnMiles"] = "Earn Miles";
  MilesTabs["RedeemMiles"] = "Redeem Miles";
  MilesTabs["UpgradeSeat"] = "Upgrade Seat";
  MilesTabs["ExcessBaggage"] = "Excess Baggage";
  return MilesTabs;
}({});
export let FlightDisruptionCertificateTabs = /*#__PURE__*/function (FlightDisruptionCertificateTabs) {
  FlightDisruptionCertificateTabs["Myself"] = "Request for myself";
  FlightDisruptionCertificateTabs["Someone"] = "Request for someone else";
  return FlightDisruptionCertificateTabs;
}({});
export let flightStatus = /*#__PURE__*/function (flightStatus) {
  flightStatus["Arrived"] = "Arrived";
  flightStatus["Departed"] = "Departed";
  flightStatus["Cancelled"] = "Cancelled";
  flightStatus["Scheduled"] = "Scheduled";
  flightStatus["Ontime"] = "On time";
  flightStatus["Delayed"] = "Delayed";
  flightStatus["Diverted"] = "Diverted";
  flightStatus["ReturnToBase"] = "Return To Base";
  return flightStatus;
}({});
export let preSelect = /*#__PURE__*/function (preSelect) {
  preSelect["origin"] = "origin";
  preSelect["destination"] = "destination";
  return preSelect;
}({});
export let PromoCabinClass = /*#__PURE__*/function (PromoCabinClass) {
  PromoCabinClass["PromoEconomy"] = "E";
  PromoCabinClass["PromoPremEconomy"] = "P";
  PromoCabinClass["PromoBusiness"] = "B";
  PromoCabinClass["PromoFirst"] = "F";
  return PromoCabinClass;
}({});